<template>
	<p></p>
</template>
<script>
	export default {
		name: "home",
		components: {
		},
		data() {
		},
		mounted() {
		},
		methods: {

		}
	};
</script>
<style>
</style> 